import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography,
  Divider,
  useTheme,
} from "@mui/material";
import { LockPersonOutlined } from "@mui/icons-material";

export default function BlockedModal({ open, onClose, productName }) {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          background: theme.palette.info.main,
          py: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              width: 80,
              height: 80,
              borderRadius: "50%",
              backgroundColor: "rgba(255,255,255,0.25)",
            }}
          />
          <Box
            sx={{
              zIndex: 1,
              backgroundColor: "rgba(255,255,255,0.3)",
              borderRadius: "50%",
              padding: 1.5,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <LockPersonOutlined sx={{ fontSize: 36, color: "#fff" }} />
          </Box>
        </Box>

        <Typography
          variant="h6"
          fontWeight={700}
          sx={{ color: "#fff", letterSpacing: 0.5 }}
        >
          Módulo Indisponível
        </Typography>
      </Box>

      <DialogContent sx={{ pt: 3, pb: 1, px: 4 }}>
        <DialogContentText
          sx={{
            textAlign: "center",
            fontSize: "0.95rem",
            color: theme.palette.text.primary,
            lineHeight: 1.6,
          }}
        >
          O acesso a este módulo está restrito à sua conta.
          <br />
          Se deseja adquirir acesso,{" "}
          <Box
            component="a"
            href={
              productName
                ? `https://wa.me/5584991414651?text=Olá,%20gostaria%20de%20adquirir%20acesso%20ao%20${productName}.`
                : "https://wa.me/5584991414651?text=Olá,%20gostaria%20de%20adquirir%20acesso%20a%20um%20novo%20produto."
            }
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: theme.palette.primary.main,
              textDecoration: "underline",
              cursor: "pointer",
              "&:hover": { opacity: 0.75 },
            }}
          >
            entre em contato
          </Box>{" "}
          com o suporte.
        </DialogContentText>
      </DialogContent>

      <Divider sx={{ mx: 3, mt: 2 }} />

      <DialogActions sx={{ justifyContent: "center", py: 2.5, px: 3 }}>
        <Button
          variant="contained"
          color="info"
          onClick={onClose}
          autoFocus
          sx={{
            borderRadius: 2,
            px: 5,
            py: 1,
            fontWeight: 600,
            textTransform: "none",
            fontSize: "0.95rem",
            color: "#fff",
            boxShadow: "none",
            "&:hover": {
              boxShadow: `0px 4px 12px ${theme.palette.primary.main}55`,
            },
          }}
        >
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
